const BookingsRoutes = {
  getBookings: "/companies/bookings",
  getBookingDetails: "/rides/details",

};

export default BookingsRoutes